import React, { useEffect, useState } from 'react'
// import Award from "../../../../Common/lib/Award/Award"

export const NomineeList = ({ award_id, award_map_id, type, competition_id, slug, hasNominated }) => {

    const [ cast, setCast ] = useState( [] )

    useEffect( () => {
        let subscribed = true
        if (subscribed && type && slug !== undefined && competition_id > 0 && award_id > 0)

            // if (type==='GROUP') {
            //     Award.getShowGroupAwardCast(slug, award_id, award_map_id, result => {
            //         // console.log('getShowGroupAwardCast',result)
            //         if (!result.error && Object.keys(result.data).length>0){
            //           setCast(result.data)
            //         }
            //     })
            // } else {
            //     Award.getShowIndividualAwardCast(slug, award_id, result => {
            //         // console.log('getShowIndividualAwardCast',result)
            //         if (!result.error && Object.keys(result.data).length>0){
            //           setCast(result.data)
            //         }
            //     })
            // }

            setCast(null)

        return () => subscribed = false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ type, award_id, competition_id, slug ])

    return (
        <div className="nomineelist__nominee--people" style={{marginTop:'.25rem'}}>
            { Object.keys(cast).length>0 ?
                cast.map( (c, i) => {

                  if (type==='GROUP') {
                      if (c.name.trim()==='Jacek Wisniewski') {
                          return (
                              <React.Fragment key={ i }>
                                  <span className="nomineelist__nominee--person">{i===0?'':', '}{ 'Jacek Wiśniewski' }</span>
                              </React.Fragment>
                          )
                      } else {
                          return (
                              <React.Fragment key={ i }>
                                  <span className="nomineelist__nominee--person">{i===0?'':', '}{ c.name }</span>
                              </React.Fragment>
                          )
                      }

                  } else {

                    if (hasNominated) {

                        if (c.nominated===1) {
                          return (
                            <React.Fragment key={ i }>
                                <div className="nomineelist__nominee--person mt-2">{ c.name }
                                    {
                                        c.role_name ?
                                            <span className="text-uppercase font-weight-light ps-2" style={{
                                                fontSize:'.6rem'
                                            }}>{c.role_name}</span>
                                            : ""
                                    }
                                    {
                                      c.winner ?
                                          <div className="label-small text-red winner-label d-flex mt-0">
                                              <div className="border-bottom flex-fill ms-4 line-small" />
                                              <div className="px-2">WINNER</div>
                                              <div className="border-bottom flex-fill me-4 line-small" />
                                          </div>
                                      :""
                                    }
                                    {
                                      c.honoree ?
                                          <div className="label-small text-red winner-label d-flex mt-0">
                                              <div className="border-bottom flex-fill ms-4 line-small" />
                                              <div className="px-2">HONOREE</div>
                                              <div className="border-bottom flex-fill me-4 line-small" />
                                          </div>
                                      :""
                                    }

                                </div>

                            </React.Fragment>
                          )
                        } else {
                          return ""
                        }


                    } else {

                      return (
                        <React.Fragment key={ i }>
                            <div className="nomineelist__nominee--person mt-2">{ c.name }
                                {
                                    c.role_name ?
                                        <span className="text-uppercase font-weight-light ps-2" style={{
                                            fontSize:'.6rem'
                                        }}>{c.role_name}</span>
                                        : ""
                                }
                                {
                                  c.winner ?
                                      <div className="label-small text-red winner-label d-flex mt-0">
                                          <div className="border-bottom flex-fill ms-4 line-small" />
                                          <div className="px-2">WINNER</div>
                                          <div className="border-bottom flex-fill me-4 line-small" />
                                      </div>
                                  :""
                                }
                                {
                                  c.honoree ?
                                      <div className="label-small text-red winner-label d-flex mt-0">
                                          <div className="border-bottom flex-fill ms-4 line-small" />
                                          <div className="px-2">HONOREE</div>
                                          <div className="border-bottom flex-fill me-4 line-small" />
                                      </div>
                                  :""
                                }

                            </div>

                        </React.Fragment>
                      )
                    }

                  }
                })
            :null}
        </div>
    )
}
